<template>
	<div class="chatBox" style="position: relative;">
		<div class="audio" v-show="recordingState.isRecording">
			<!-- <audio controls  :src="audioURL"></audio>v-if="audioURL" -->
			<div class="top">
				<div class="left">
					<div class="red"></div>
					<span>正在录音...</span>
				</div>
				<div class="right">{{ formatTime(recordingState.duration || 0) }}</div>
			</div>
			<div class="bottom">
				<div class="lineBox">
					<div class="strip to-purple-600 from-green-400"
						:style="{ width: Math.min((recordingState.duration || 0) * 2, 100) + '%' }"></div>
					<!-- 录音进度条 -->
					<div class="ylNumber">
						<div class="number"><span
								style="color: #4169e1;margin-right: 3px;">⏱</span>{{ formatTime(recordingState.duration || 0) }}
						</div>
					</div>
					<!-- 录音时长 -->
					<div class="line" v-for="item in 10" :key="item"></div>
				</div>
				<!-- 音量分割线 -->
				<div class="hdbh" :class="{ 'pulse-active': recordingState.isRecording }"></div>
				<!-- 闪动背景 -->
			</div>
		</div>

		<!-- 失败的录音记录 - 浮动显示（移到chat_dom外面，固定在chatBox上） -->
		<div v-if="failedRecordings.length > 0" class="failed-recordings-floating">
			<!-- 折叠/展开按钮 -->
			<div class="floating-header" @click="isFailedRecordingsCollapsed = !isFailedRecordingsCollapsed">
				<i class="el-icon-warning" style="color: #f56c6c;"></i>
				<span class="title-text">录音识别失败 ({{ failedRecordings.length }})</span>
				<i :class="isFailedRecordingsCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
			</div>

			<!-- 失败记录列表（可折叠） -->
			<div v-if="!isFailedRecordingsCollapsed" class="failed-recordings-list">
				<div v-for="recording in failedRecordings" :key="recording.id" class="failed-recording-item">
					<div class="recording-header">
						<span class="recording-time">{{ formatFailedRecordingTime(recording.timestamp) }}</span>
					</div>
					<div class="recording-content">
						<div class="recording-info">
							<div class="error-msg">错误信息：{{ recording.error }}</div>
							<div class="file-name">文件：{{ recording.fileName }}</div>
						</div>
						<div class="recording-actions">
							<el-button type="primary" size="mini" @click="handleRetry(recording.id)"
								icon="el-icon-refresh">重试</el-button>
							<el-button type="text" size="mini" @click="handleDeleteFailedRecording(recording.id)"
								style="color: #909399;">删除</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="chat_dom" ref="chat_dom" style="position: relative;">
			<div class="text">{{ defaultWelcomeText }}
				<!-- 按钮已屏蔽 -->
			</div>

			<!-- 聊天对话  -->
			<div v-for="(item, index) in chatData" :key="index" class="chat_list">
				<!-- ai左 -->
				<div v-if="item.role === 'assistant'" class="left_dom">
					<img src="../../image/robot.png" alt srcset style="width: 33px;height: 33px;" />
					<div class="left_dom_text">
						{{ item.content}}
						<!-- AI回复的引用按钮已屏蔽 -->
					</div>
					<div class="time">{{ formatChatTime(item.createTime) }}</div>
				</div>
				<!-- 医生右 -->
				<div v-if="item.role === 'user'" class="right_dom">
					<div class="right_dom_text" :class="{'recording-content': item.isRecordingContent}">
						<div>
							{{ item.content}}
							<div class="btn">
								<button @click="createByOneBtn(item)"><svg focusable="false" data-icon="save"
										width="1em" height="1em" fill="currentColor" aria-hidden="true"
										viewBox="64 64 896 896">
										<path
											d="M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z">
										</path>
									</svg>引用</button>
								<button @click="updateBtn(item)"><i class="el-icon-edit"></i>重新编辑</button>
							</div>
						</div>
					</div>
					<img style="width: 35px;height: 35px;" :src="require('../../image/ys.png')" alt srcset />
					<div class="time">{{ formatChatTime(item.createTime) }}</div>
				</div>
				<div class="clearboth"></div>
			</div>
		</div>
		<!-- -->
		<!-- 消息模版 -->
		<div class="templateList" v-if="false" :style="{ height: templateListHeight + 'px'  }" ref2="常见问题的位置"
			style="display: none;">
			<!-- 上下分隔符 -->
			<div class="vertical-divider" @mousedown="startVerticalResize" ref="verticalDivider">
				<div class="vertical-divider-handle"></div>
			</div>
			<div class="title">常见问题：
				<div class="selBox">
					<el-tooltip class="item" :open-delay=800 effect="dark" content="添加自定义常用问题" placement="top">
						<el-button type="text" size="mini" @click="addTemplate"><i
								class="el-icon-circle-plus-outline"></i>添加</el-button>
					</el-tooltip>
				</div>
			</div>

			<div class="templateList_box wtlist">
				<div v-for="(item, index) in templateList" :key="index" class="templateList_item">
					<div v-if="!item.id" class="templateList_itemX">
						<input type="text" size="mini" placeholder="请输入" v-model="item.message" />
						<el-button size="mini" type="text" style="margin-left:20px"
							@click="saveTemplate(item)">保存</el-button>
					</div>
					<div v-else @click="clickTemplateText(item.message)" class="list-x">
						<div class="templateText">{{item.message}}</div>
						<i class="el-icon-close" @click.stop="deleteTemplate(item.id)"></i>
					</div>
				</div>
			</div>
		</div>
		<!-- 输入框 -->



		<div class="input_dom">
			<div class="left">
				<textarea placeholder="请输入..." v-model="textarea" row="5" @keydown.enter="handleEnter"
					style="padding:5px 10px"></textarea>
			</div>
			<div class="right">

				<!-- 发送按钮移到最上面 -->
				<button type="button" v-if="textarea === ''" class="ant-btn disabled"><i class="el-icon-position"></i>
					发送</button>
				<el-tooltip class="item" :open-delay=800 effect="dark" content="发送消息给AI医疗助手" placement="top" v-else>
					<button type="button" @click="sendBtn" class="ant-btn send-btn"><i class="el-icon-position"></i>
						发送</button>
				</el-tooltip>

				<!-- 常见问题弹出框 -->
				<el-popover placement="top" width="300" v-model="popoverVisible" trigger="manual">
					<div>
						<div v-for="(q, idx) in commonQuestions" :key="q.id || idx" class="common-question-item"
							@click="selectCommonQuestion(q)">
							{{ q.name }}
						</div>
					</div>
					<template #reference>

						<el-tooltip class="item" :open-delay=800 effect="dark" content="发送常见问题" placement="top">
							<button type="button" class="ant-btn blue" style="width:7rem;"
								@click="toggleCommonQuestions">
								<i class="el-icon-chat-dot-round"></i> 常见问题
							</button>
						</el-tooltip>

					</template>
				</el-popover>

				<!-- 维护问题 -->
				<el-tooltip class="item" :open-delay=800 effect="dark" content="常见问题维护" placement="top">
					<button type="button" @click="popQuestion" class="ant-btn blue" style="width:7rem;"><i
							class="el-icon-document"></i> 维护问题</button>
				</el-tooltip>
				<!--        <button type="button" class="ant-btn disabled" v-if="false"><i class="el-icon-video-play"></i> 暂停生成</button>-->
				<!--        <el-tooltip class="item" :open-delay=800  effect="dark" content="停止AI正在生成的回复" placement="top" v-else>-->
				<!--          <button type="button" class="ant-btn"><i class="el-icon-video-play"></i> 暂停生成</button>-->
				<!--        </el-tooltip>-->
			</div>
		</div>
		<el-dialog title="维护常见问题" :visible.sync="dialogVisible" width="400px" custom-class="maintain-dialog"
			@close="cancelEdit" append-to-body :z-index="3000" :close-on-click-modal="false">
			<div>
				<el-input v-model="newQuestion" placeholder="请输入新问题，回车添加" @keyup.enter.native="addQuestion">
					<template #append>
						<el-button @click="addQuestion" type="primary" icon="el-icon-plus" circle></el-button>
					</template>
				</el-input>
				<el-table :data="editQuestions" style="width: 100%;" border size="mini" :show-header="false">
					<el-table-column>
						<template slot-scope="scope">
							<span style="font-size: 0.95rem;">{{ scope.row.name }}</span>
						</template>
					</el-table-column>
					<el-table-column width="90">
						<template slot-scope="scope">
							<el-button type="danger" icon="el-icon-delete" circle
								@click="removeQuestion(scope.$index)"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelEdit">取 消</el-button>
				<el-button type="primary" @click="saveQuestions">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import {
		request
	} from "@/utils/request";
	export default {
		name: "ChatBox",
		components: {},
		props: {
			tip: {
				type: String
			},
			chatData: {
				type: Array
			},
			selectedTemplate: {
				type: String,
				default: "通用模板"
			},
			recordingState: {
				type: Object,
				default: () => ({
					isRecording: false,
					duration: 0
				})
			},
			patientName: {
				type: String,
				default: ""
			},
			currentChatId: {
				type: String,
				default: ""
			},
			currentMedmstrId: {
				type: [String, Number],
				default: ""
			}
			/* 默认输入 */
			// textareaDeful: {
			//   type: String
			// }
		},
		computed: {
			...mapState(["userInfo"]),
			defaultWelcomeText() {
				if (this.patientName) {
					return `您好，我是AI医疗助手。我已加载${this.patientName}患者的基本信息，请继续问诊。`;
				}
				return "您好，我是AI医疗助手。请描述患者的症状，我会协助您进行问诊和记录。";
			}
		},
		watch: {
			selectedTemplate(newVal) {
				this.selectTemplateName = newVal;
				this.init();
			},
			// 监听当前病历ID的变化，切换病历时重新加载失败录音记录
			currentChatId(newVal, oldVal) {
				// 只有在病历ID发生变化时才重新加载
				if (newVal !== oldVal) {
					this.loadFailedRecordings();
				}
			}
			// 如果你需要在prop变化时执行特定的逻辑，可以使用watch
			// textareaDeful(newVal, oldVal) {
			//   console.log("Prop changed:", newVal, oldVal);
			//   this.textarea = newVal;
			// }
		},
		async created() {
			this.selectTemplateName = this.selectedTemplate;
			this.init();
			// 不在初始化时加载录音记录，等待用户选择病历后再加载
		},
		mounted() {
			// 添加垂直调节的全局事件监听器
			document.addEventListener('mousemove', this.handleVerticalMouseMove);
			document.addEventListener('mouseup', this.handleVerticalMouseUp);
		},
		beforeDestroy() {
			// 移除事件监听器
			document.removeEventListener('mousemove', this.handleVerticalMouseMove);
			document.removeEventListener('mouseup', this.handleVerticalMouseUp);
		},
		data() {
			return {
				textarea: "",
				isMore: false,
				item: {},
				loading: false,
				batchQuoteVisible: false, // 批量引用确认对话框显示状态
				statusList_select: [{
						name: "儿科问诊模板"
					},
					{
						name: "慢性病随访模板"
					},
					{
						name: "常见感冒模版"
					}
				],
				selectTemplateName: "",
				// 垂直调节相关
				templateListHeight: 200, // 常见问题区域默认高度
				isVerticalResizing: false, // 是否正在垂直调节
				startY: 0, // 鼠标开始位置Y
				startHeight: 0, // 开始时的高度
				// 新增：常见问题（后台返回 {id,name}），初始化为空
				commonQuestions: [],
				popoverVisible: false, // 控制popover显示 选择常见问题
				// 新增
				dialogVisible: false, // 控制弹窗显示
				editQuestions: [], // 弹窗内编辑用副本
				newQuestion: "", // 新增输入框
				failedRecordings: [], // 失败的录音记录列表
				isFailedRecordingsCollapsed: false // 控制失败录音记录的折叠状态
			};
		},
		methods: {
			async init() {
				// 加载常见问题
				try {
					const resp = await request({
						url: '/ly/careProfessionals/querySpecialtyConsultationTemplateList',
						method: 'GET',
						params: {
							id: this.userInfo.id
						}
					});
					if (resp && resp.success && Array.isArray(resp.result)) {
						this.commonQuestions = resp.result.map(it => ({
							id: it.id,
							name: it.name
						}));
					} else {
						this.commonQuestions = [];
					}
				} catch (e) {
					this.commonQuestions = [];
				}
				// 模板旧逻辑已废弃
			},
			updateStatusBtn(item_status, item) {
				this.selectTemplateName = item_status.name;
				this.init();
			},
			/***常见问题 */
			popQuestion() {
				// 打开弹窗时，复制一份当前问题列表
				this.editQuestions = this.commonQuestions.map(q => ({
					id: q.id,
					name: q.name
				}));
				this.newQuestion = "";
				this.dialogVisible = true;
			},
			addQuestion() {
				if (this.newQuestion.trim()) {
					const id = Date.now().toString().slice(-8);
					this.editQuestions.push({
						id,
						name: this.newQuestion.trim()
					});
					this.newQuestion = "";
				}
			},
			removeQuestion(idx) {
				this.editQuestions.splice(idx, 1);
			},
			async saveQuestions() {
				// 提交整个列表到后端，采用覆盖保存策略
				const payload = {
					id: this.userInfo.id,
					settings: this.editQuestions.map(q => ({
						id: q.id,
						name: q.name
					}))
				};
				try {
					const resp = await request({
						url: '/ly/careProfessionals/updateProfessionalSettingsByMainId',
						method: 'POST',
						data: payload
					});
					if (resp && resp.success) {
						// 覆盖本地列表并关闭弹窗
						this.commonQuestions = this.editQuestions.map(q => ({
							id: q.id,
							name: q.name
						}));
						this.$message.success('已保存常见问题');
						this.dialogVisible = false;
					} else {
						this.$message.error(resp?.message || '保存失败');
					}
				} catch (e) {
					this.$message.error('网络错误，保存失败');
				}
			},
			cancelEdit() {
				this.dialogVisible = false;
			},
			toggleCommonQuestions() {
				// 检查常见问题是否为空
				if (!this.commonQuestions || this.commonQuestions.length === 0) {
					// 不弹窗，并提示用户先维护问题
					this.popoverVisible = false;
					this.$message.warning('请先维护常见问题');
					return;
				}
				this.popoverVisible = !this.popoverVisible;
			},
			selectCommonQuestion(question) {
				// question: { id, name }
				this.textarea = question?.name || '';
				this.popoverVisible = false; // 选中后关闭弹窗
				// 自动发送
				this.$nextTick(() => {
					this.sendBtn();
				});
			},
			/* 发送 */
			sendBtn() {
				if (this.textarea === "") {
					this.$message({
						type: "error",
						message: "请输入内容!"
					});
				} else {
					console.log("this.textarea", this.textarea);
					const content = this.textarea; // 保存内容
					this.$emit("sendBtn", content);
					// 发送后清空输入框
					this.$nextTick(() => {
						this.textarea = "";
					});
				}
			},
			/* 键盘回车事件处理 */
			handleEnter(event) {
				if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
					console.log("换行");
				} else if (event.keyCode == 13) {
					this.sendBtn();
					event.preventDefault();
				}
			},
			// 旧模板增删改逻辑已移除；“添加”按钮打开本地维护弹窗
			addTemplate() {
				this.popQuestion();
			},
			//全量匹配
			createBtn() {
				this.$emit("createBtn");
			},
			// 全引按钮
			extractFullContentBtn() {
				this.$emit("extractFullContent");
			},
			createByOneBtn(item) {
				this.$emit("createByOneBtn", item);
			},
			//单条引用
			deleteBtn() {
				this.$emit("deleteBtn");
			},
			updateBtn(content) {
				this.$emit("updateBtn", content);
			},

			/* 加载失败的录音记录 */
			async loadFailedRecordings() {
				try {
					// 如果没有选中病历，清空失败录音列表
					if (!this.currentChatId) {
						this.failedRecordings = [];
						return;
					}

					const {
						getFailedRecordingsByChatId
					} = await import('@/utils/recordingStorage');

					// 根据当前病历的 chatId 获取失败录音记录
					const allRecordings = getFailedRecordingsByChatId(this.currentChatId);

					// 过滤：只显示2小时内的记录
					const twoHoursAgo = Date.now() - 2 * 60 * 60 * 1000;
					this.failedRecordings = allRecordings.filter(recording => recording.timestamp > twoHoursAgo);
				} catch (error) {
					console.error('加载失败录音记录出错：', error);
					this.failedRecordings = [];
				}
			},

			/* 重试失败的录音 */
			handleRetry(recordingId) {
				// 调用父组件的重试方法
				this.$emit('retryRecording', recordingId);
			},

			/* 删除失败的录音记录 */
			async handleDeleteFailedRecording(recordingId) {
				try {
					await this.$confirm('确定要删除这条失败的录音记录吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const {
						deleteFailedRecording
					} = await import('@/utils/recordingStorage');
					await deleteFailedRecording(recordingId);

					this.$message.success('已删除录音记录');

					// 重新加载列表
					await this.loadFailedRecordings();
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除失败录音记录出错：', error);
						this.$message.error('删除失败');
					}
				}
			},

			/* 格式化失败录音的时间 */
			formatFailedRecordingTime(timestamp) {
				const date = new Date(timestamp);
				const now = new Date();
				const diff = now.getTime() - timestamp;

				// 如果在1分钟内
				if (diff < 60 * 1000) {
					return '刚刚';
				}
				// 如果在1小时内
				if (diff < 60 * 60 * 1000) {
					const minutes = Math.floor(diff / (60 * 1000));
					return `${minutes}分钟前`;
				}
				// 如果在今天
				if (date.toDateString() === now.toDateString()) {
					return `今天 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
				}
				// 其他情况显示完整日期
				return `${date.getMonth() + 1}-${date.getDate()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
			},

			// 批量引用AI回复
			confirmBatchQuote() {
				this.batchQuoteVisible = false;

				// 筛选出所有AI回复
				const aiReplies = this.chatData.filter(item => item.role === 'assistant');

				if (aiReplies.length === 0) {
					this.$message.warning("暂无AI回复可引用");
					return;
				}

				// 发送批量引用事件
				this.$emit("batchQuoteAiReplies", aiReplies);

				this.$message.success(`已引用 ${aiReplies.length} 条AI回复`);
			},

			// 垂直调节相关方法
			startVerticalResize(event) {
				this.isVerticalResizing = true;
				this.startY = event.clientY;
				this.startHeight = this.templateListHeight;
				document.body.style.cursor = 'ns-resize';
				document.body.style.userSelect = 'none';
				event.preventDefault();
			},

			handleVerticalMouseMove(event) {
				if (!this.isVerticalResizing) return;

				const deltaY = this.startY - event.clientY; // 向上拖拽为正值
				const newHeight = Math.max(50, Math.min(400, this.startHeight + deltaY));
				this.templateListHeight = newHeight;
			},

			handleVerticalMouseUp() {
				if (this.isVerticalResizing) {
					this.isVerticalResizing = false;
					document.body.style.cursor = '';
					document.body.style.userSelect = '';
				}
			},
			formatTime(duration) {
				const minutes = Math.floor(duration / 60);
				const seconds = Math.floor(duration % 60);
				return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
			},
			/* 格式化聊天时间为 小时:分钟 格式（例如：00:09） */
			formatChatTime(dateString) {
				if (!dateString) return '--:--';
				try {
					// 处理 "2025-11-17 00:09:03" 格式
					const date = new Date(dateString);
					if (isNaN(date.getTime())) {
						// 如果Date解析失败，尝试手动解析
						const match = dateString.match(/(\d{2}):(\d{2}):(\d{2})/);
						if (match) {
							// match[1]是小时，match[2]是分钟
							// 返回小时:分钟格式
							return `${match[1]}:${match[2]}`;
						}
						return '--:--';
					}
					const hours = String(date.getHours()).padStart(2, '0');
					const minutes = String(date.getMinutes()).padStart(2, '0');
					return `${hours}:${minutes}`;
				} catch (error) {
					console.error('时间格式化错误:', error);
					return '--:--';
				}
			}
		}
	};
</script>

<style scoped lang="less">
	.common-question-item {
		font-size: 0.95rem !important;
		padding: 12px 16px !important;
		cursor: pointer;
		transition: all 0.2s ease;
		border-radius: 6px;

		&:hover {
			background-color: #f5f5f5 !important;
			color: #4169e1 !important;
		}
	}

	/* 失败录音记录浮动样式 */
	.failed-recordings-floating {
		position: absolute;
		top: 16px;
		right: 16px;
		width: 350px;
		max-height: 60vh;
		z-index: 100;
		background: #ffffff;
		border: 1px solid #fde2e2;
		border-radius: 12px;
		box-shadow: 0 4px 16px rgba(245, 108, 108, 0.2);
		overflow: hidden;

		.floating-header {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 12px 16px;
			background-color: #fff3f3;
			cursor: pointer;
			user-select: none;
			transition: all 0.3s ease;

			&:hover {
				background-color: #ffe9e9;
			}

			i {
				font-size: 14px;
				color: #f56c6c;
			}

			.title-text {
				flex: 1;
				font-size: 14px;
				font-weight: 600;
				color: #f56c6c;
			}

			i:last-child {
				color: #909399;
				font-size: 12px;
			}
		}

		.failed-recordings-list {
			max-height: calc(60vh - 48px);
			overflow-y: auto;
			padding: 8px;

			.failed-recording-item {
				background-color: #fff3f3;
				border: 1px solid #fde2e2;
				border-radius: 8px;
				padding: 10px 12px;
				margin-bottom: 8px;
				transition: all 0.3s ease;

				&:hover {
					box-shadow: 0 2px 8px rgba(245, 108, 108, 0.15);
				}

				.recording-header {
					margin-bottom: 8px;

					.recording-time {
						font-size: 11px;
						color: #909399;
					}
				}

				.recording-content {
					display: flex;
					flex-direction: column;
					gap: 10px;

					.recording-info {
						flex: 1;
						font-size: 12px;
						color: #606266;

						.error-msg {
							margin-bottom: 6px;
							color: #f56c6c;
							font-size: 11px;
							word-wrap: break-word;
						}

						.file-name {
							color: #909399;
							font-size: 10px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}

					.recording-actions {
						display: flex;
						gap: 8px;
						justify-content: flex-start;

						.el-button--mini {
							padding: 5px 10px;
							font-size: 12px;
						}
					}
				}
			}
		}
	}
</style>
<style scoped lang="less">
	@import './index.less';
</style>